import { createMiddleware } from '@tanstack/react-start';

import { apiAuthMiddleware } from './apiAuthMiddleware';
import { errorHandlingMiddleware } from './errorHandlingMiddleware';
import { userAuthMiddleware } from './userAuthMiddleware';

/**
 * Standard middlewares that should applied to all functions.
 *
 * Order matters! Middlewares run from outside to inside:
 * 1. userAuthMiddleware - adds user context first
 * 2. apiAuthMiddleware - adds API clients
 * 3. errorHandlingMiddleware - can access user context when errors occur
 */
export const standardMiddlewares = createMiddleware({
  type: 'function',
}).middleware([userAuthMiddleware, apiAuthMiddleware, errorHandlingMiddleware]);
